<template>
    <div class="AstaSearchResultat">
        <!--TODO: Asta resultat-->
        <Filter @display-change="d => updateStatus(d)" @filter-change="f => updateStatus(f)" />
        <SearchHeader />
        <InfoView />
        <!-- debug-test-mm -->
        <button @click="astaStore.debug">Debug</button>
        Alla urvalsgrupper: {{ astaStore.allaUrvalsgrupper }}
        <!-- /debug-test-mm -->
        <div class="row">
            <div class="SearchResultat" aria-live="polite">
                <ResultHeader />
                <Item v-for="(item) in astaStore.result?.data" :item="item" />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { onMounted } from 'vue';

import type { AstaDisplaySettings, AstaFilterSettings } from '../../types/AstaTypes';
import useAstaStore from '../stores/AstaStore';

import Filter from './Filter.vue';
import ResultHeader from './ResultHeader.vue';
import SearchHeader from './SearchHeader.vue';
import InfoView from './InfoView.vue';
import Item from './Item.vue';

const astaStore = useAstaStore();
astaStore.init(Asta, AstaResultatStatus);

onMounted(() => {
    astaStore.search();
});

const updateStatus = (status: AstaDisplaySettings | AstaFilterSettings) => {
    console.log('updateStatus:', status);
};

</script>